import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { RarDataAPIResponse } from 'src/services/rar-data-api/types/RarDataAPIResponse';
import type { NextConfig } from 'src/types/nextConfig';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const RAR_DATA_API_URL = publicRuntimeConfig.endpoints.rarData;

export const fetchProductReviews = async (
  productCode: number,
  { page = 1, perPage = 3 }: { page?: number; perPage?: number } = {},
): Promise<RarDataAPIResponse> => {
  const requestUrl = new URL(`${RAR_DATA_API_URL}${productCode}`);

  requestUrl.searchParams.set('page', String(page));
  requestUrl.searchParams.set('perPage', String(perPage));

  const response = await fetchJSONWithTimeout(requestUrl.toString());

  return response.json();
};
